export interface PlacementInfo {
    uid: string;
    applicationFormId: number;
    status: PlacementInfoStatus;
    placementType: PlacementType;
    applicantRegionalContact?: string;
    applicantLocalContact?: string;
    schoolName?: string;
    schoolStatus?: PlacementSchoolStatus;
    schoolDateStatus?: PlacementSchoolDateStatus;
    isHFAppFormNeeded: boolean;
    hfAppFormFile?: string;
    hfAppFormComment?: string;
    isSingleParent: boolean;
    isDoublePlacement: boolean;
    isSharingBedroom?: boolean;
    sharingBedroomDetails?: string;
    hfName?: string;
    hfMobilePhone?: string;
    hfEmail?: string;
    hfPhone?: string;
    hfCity?: string;
    hfStreet?: string;
    hfState?: string;
    hfZip?: string;
    parent1FirstName?: string;
    parent1Age?: string;
    parent1Occupation?: string;
    parent1Phone?: string;
    parent2FirstName?: string;
    parent2Age?: string;
    parent2Occupation?: string;
    parent2Phone?: string;
    childrenDetails?: string;
    hasPets?: boolean;
    petsDetails?: string;
    hobbiesDetails?: string;
    specificImmunisation?: string;
    specificImmunisationDetails?: string;
    displayComment?: string;
    placementDocuments: PlacementDocument[];
  }
  
  export enum PlacementInfoStatus {
    Active = 0,
    Inactive = 1,
  }
  
  export enum PlacementType {
    Permanent = 0,
    Temporary = 1,
    Welcome = 2,
    Replacement = 3
  }
  
  export enum PlacementSchoolStatus {
    ToBeAdvised = 0,
    SchoolPending = 1,
    Confirmed = 2
  }
  
  export enum PlacementSchoolDateStatus {
    Approximative = 0,
    ToBeAdvised = 1,
    Confirmed = 2,
  }
  
  export interface PlacementDocument {
    uid: string;
    name: string;
    file: string;
  }
  